import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import NoDataResource from '../../../common/resource/NoDataResource';
import {
  BANK_PATH,
  BILLING_REPORT_DETAIL_PATH,
} from '../../../../config/paths';
import {
  clearBillingReportDetail,
  getBillingReportDetail,
} from '../../../../actions';
import BillProcessReportDetailResource from './resource/BillProcessReportDetailResource';

export const BillReportDetail = ({
  breadcrumbs,
  match: {
    params: { id: billingReporDetailId },
  },
  billingReportDetail,
  loading,
  dispatchGetBillingReportDetail,
  dispatchClearBillingReportDetail,
}) => {
  useLayoutEffect(() => {
    dispatchGetBillingReportDetail({ billingReporDetailId });

    return () => dispatchClearBillingReportDetail();
  }, []);

  let content = null;
  if (loading) content = <Loader />;
  else if (billingReportDetail.isEmpty()) {
    content = <NoDataResource returnPage={BANK_PATH} />;
  } else {
    const bankJSON = billingReportDetail.toJS();
    content = <BillProcessReportDetailResource {...bankJSON} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Registro de Ventas e Ingreso"
      content={content}
    />
  );
};

BillReportDetail.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  billingReportDetail: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetBillingReportDetail: PropTypes.func.isRequired,
  dispatchClearBillingReportDetail: PropTypes.func.isRequired,
};

BillReportDetail.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Registro de Ventas e Ingresos',
      href: BILLING_REPORT_DETAIL_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  billingReportDetail: AccountingUnit.Billing.getIn([
    'detail',
    'current',
    'content',
  ]),
  loading: !AccountingUnit.Billing.getIn([
    'detail',
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetBillingReportDetail: getBillingReportDetail,
  dispatchClearBillingReportDetail: clearBillingReportDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillReportDetail);
